import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function FloatingReview() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const reviews = [{
    quote: 'Exceptional quality and fast turnaround.',
    author: 'James M.',
    role: 'Manufacturing Director'
  }, {
    quote: 'Our go-to supplier for compliance labels.',
    author: 'Sarah L.',
    role: 'Procurement Manager'
  }, {
    quote: '25 years of reliable partnership.',
    author: 'David K.',
    role: 'Operations Lead'
  }];
  useEffect(() => {
    const startTimer = setTimeout(() => setIsVisible(true), 3000);
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % reviews.length);
        setIsVisible(true);
      }, 500);
    }, 7000);
    return () => {
      clearTimeout(startTimer);
      clearInterval(interval);
    };
  }, [reviews.length]);
  return <div className="fixed bottom-6 left-6 z-40 hidden lg:block" data-id="element-128">
      <AnimatePresence data-id="element-129">
        {isVisible}
      </AnimatePresence>
    </div>;
}